import React from 'react';
import classnames from 'classnames';

class labelInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      newInput: '',
      isAgeError: false,
      ageErrorMsg: false,
      isDCTPDError: false,
      DCTPDErrorMsge: false,
      isIPError: false,
      IPErrorMsg: false
    };

    this.update = this.update.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  update(e) {    
    this.setState({value: e.target.value});
  }

  onBlur(e){
    e.preventDefault();
    if(this.props.roundOffValue === 1000) {
      if(e.target.value > 1000) {
        let updatedDeathValue = Math.round(e.target.value/1000)*1000 + '';
          // this.setState({
          //   value: updatedDeathValue
          // },() => this.props.callbackParent(this.state.value));
          this.setState(prevState => ({
            value: updatedDeathValue
          }), () => this.props.callbackParent(this.state.value));
      }
      // clear input if emptied
      this.props.callbackParent(this.state.value);
    } else if(this.props.roundOffValue === 500){
      if(e.target.value > 500) {
        let updatedTPDValue = Math.round(e.target.value/500)*500 + '';
        this.setState({
          value: updatedTPDValue
        },() => this.props.callbackParent(this.state.value));
      }
      // clear input if emptied
      this.props.callbackParent(this.state.value);
    }

    if(this.props.onChange) {
      this.props.onChange(e);
    }

    if(this.props.onBlur) {
      this.props.onBlur(e);
    }

    this.validate(e);
  }

  validate(e) {
    if(this.props.validateAge) {
      if(e.target.value < 16 || e.target.value > 69) {
        this.setState({isAgeError: true}, () => this.props.callbackParent(this.state.isAgeError));
      } else {
        this.setState({isAgeError: false}, () => this.props.callbackParent(this.state.isAgeError));
      }
    }

    if(this.props.validateMinMaxDCTPD && this.props.roundOffValue === 1000) {
      if(this.state.value >= 1000 && this.state.value <= 3000000) {
        this.setState({isDCTPDError: false}, () => this.props.callbackError(this.state.isDCTPDError));
      } else {
        this.setState({isDCTPDError: true}, () => this.props.callbackError(this.state.isDCTPDError));
      }
      if(this.state.value === "" || this.state.value === '' || this.state.value === null) {
        this.setState({isDCTPDError: false}, () => this.props.callbackError(this.state.isDCTPDError));
      }
    }

    if(this.props.validateMinMaxIP && this.props.roundOffValue === 500) {
      if(this.state.value >= 500 && this.state.value <= 50000) {
        this.setState({isIPError: false}, () => this.props.callbackError(this.state.isIPError));
      } else {
        this.setState({isIPError: true}, () => this.props.callbackError(this.state.isIPError));
      }
      if(this.state.value === "" || this.state.value === '' || this.state.value === null){
        this.setState({isIPError: false}, () => this.props.callbackError(this.state.isIPError));
      }
    }

    this.setState({
      validating: true
    });
  }

  handleKeyPress(e) {
    // remove uwanted characters from input field

    //TODO : special case for the strict numeric patterns, I tried using input type="number" instead, with a step value of "0.01":
    // <input type="number" step="0.01">

    if(e.charCode < 48 || e.charCode > 57) {
      e.preventDefault();
    }
  }

  render() {
    return (
      <div className="control simple-input">
        <label>{this.props.label}</label>
        {
          this.props.toolTip
          ? <div className="tool-tip"><span className="tool-tip--text">{this.props.toolTip}</span></div>
          : null
        }
        {
          this.props.labelSubtext
          ? <p className="label-subtext">{this.props.labelSubtext}</p>
          : null
        }
        {
          this.props.roundOffValue
          ? <span className="dollar-value"><input type={this.props.type} step="0.01" className={classnames('number-value', {'is-error': this.state.isError})} pattern={this.props.pattern} value={this.state.value} onBlur={this.onBlur} onChange={this.update} onKeyPress={this.handleKeyPress} /></span>
          : <input type={this.props.type} step="0.01" className={classnames('standard-value', {'is-error': this.state.isError})} pattern={this.props.pattern} onBlur={this.onBlur} onChange={this.props.update} onKeyPress={this.handleKeyPress}/>
        }
        {
          this.state.isAgeError
          ? <span className="error-text">You must be age 16 - 69 to be eligible for QSuper insurance</span>
          : null
        }
        {
          this.state.isDCTPDError
          ? <span className="error-text">Please enter an amount between $1,000 and $3,000,000</span>
          : null
        }
        {
          this.state.isIPError
          ? <span className="error-text">Please enter an amount between $500 and $50,000</span>
          : null
        }

          </div>
    );
  }
}

labelInput.defaultProps = {
	roundOffValue: 0,
  label: '',
  validateAge: false,
  validateMinMaxDCTPD: false,
  validateMinMaxIP: false,
  type: 'number',
  pattern: '',
  callbackParent: function(){},
  callbackError: function(){},
  onChange: function(){},
  labelSubtext: '',
  update: function(){},
  toolTip: null
};

labelInput.propTypes = {
	roundOffValue: React.PropTypes.number.isRequired,
  label: React.PropTypes.string.isRequired,
  validateAge: React.PropTypes.bool.isRequired,
  validateMinMaxDCTPD: React.PropTypes.bool.isRequired,
  validateMinMaxIP: React.PropTypes.bool.isRequired,
  callbackParent: React.PropTypes.func.isRequired,
  callbackError: React.PropTypes.func.isRequired,
  labelSubtext: React.PropTypes.string.isRequired,
  update: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onBlur: React.PropTypes.func.isRequired,
  type: React.PropTypes.string.isRequired,
  pattern: React.PropTypes.string.isRequired,
  toolTip: React.PropTypes.string
};

export default labelInput;



// WEBPACK FOOTER //
// ./src/components/forms/labelInput.js